import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-hosted Inter. A JS import so Vite resolves the package and fingerprints
// the woff2 files into dist/ — there is no Google Fonts request at runtime,
// because this app runs on a LAN that may have no internet at all
// (CONTRACT §8). The variable build is one file for every weight.
import '@fontsource-variable/inter';

import '@/styles/index.css';

import { bootstrapTheme } from '@/lib/useTheme';
import App from '@/App';

// Before first render: index.html already set the class to avoid a flash, this
// re-applies it from the same source of truth and starts listening for OS
// theme changes.
bootstrapTheme();

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
